import React from "react";

const ForgetPassword = () => {
  return (
    <div>
      <div
        className={
          "w-screen h-screen flex justify-center bg-gradient-to-t from-[#305FAA] to-[#17366D]"
        }
      >
        <div
          className={"flex flex-col w-full max-w-[1000px] pt-4 items-center"}
        >
          <img
            src={"/logo.png"}
            alt="logo"
            width={130}
            className={"self-start"}
          />
          <div
            className={
              "flex flex-col flex-1 w-full justify-start items-center pt-32 max-w-[500px] px-4"
            }
          >
            <p className={"text-4xl text-white font-light"}>
              RESET YOUR PASSWORD
            </p>
            <form className={"w-full gap-5 mt-10 flex flex-col"}>
              <div className={"w-full flex flex-col items-start"}>
                <label
                  htmlFor={"email"}
                  className={"text-white text-[1.125rem]"}
                >
                  EMAIL
                </label>
                <input
                  id={"email"}
                  className={
                    "bg-white w-full rounded-[4px] p-2 outline-none h-12"
                  }
                  // onChange={onChangeHandler}
                  // value={data.email}
                  // disabled={loading}
                  type={"tel"}
                />
                {/*{data.error.email && (*/}
                {/*    <p className={"text-red-600"}>{data.error.email}</p>*/}
                {/*)}*/}
              </div>
              <div className={"w-full flex items-center justify-center"}>
                <button
                  className={
                    "bg-[#43CB49] px-5 py-1 rounded text-white text-xl h-12 w-80 flex justify-center items-center hover:bg-[#306abc]"
                  }
                  type={"submit"}
                  // disabled={loading}
                >
                  Send Password Reset Link
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ForgetPassword;
